import React from "react";

const home = ({ state }) => {
  const { jobs, members } = state;

  return (
    <div className="rounded-lg dark:border-gray-700">
      <div className="flex items-center justify-center py-6 mb-4 rounded bg-gray-50 dark:bg-gray-800">
        <h3 className="dark:text-white text-4xl text-center">Muladi Govt. Mahmudjan Model Secondary School Alumni Association</h3>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="flex items-center justify-center rounded bg-gray-50 h-28 dark:bg-gray-800">
          <h3 className="dark:text-white text-xl">Total Member: {members?.filter((member) => member.is_approved)?.length}</h3>
        </div>
        <div className="flex items-center justify-center rounded bg-gray-50 h-28 dark:bg-gray-800">
          <h3 className="dark:text-white text-xl">Total Job Post: {jobs?.length} </h3>
        </div>
      </div>
    </div>
  );
};

export default home;
